import { EnhancedPoi, Poi } from "./poiCard";
import { EnhancedProductCard, ProductCard } from "./productCard";

// 供给类型
export enum SupplyType {
  Wayne = 1, // 韦恩
  GroupBuy = 2, // 团购
}

export enum SupplyCallbackType {
  Default = 1, // 默认供给
  CouponCallback = 2, // 券召回供给
}

// 韦恩供给
export interface WayneSupplyCard {
  supplyType: SupplyType.Wayne;
  productCard: null;
  poiCard: Poi;
}

// 团购供给
export interface GroupBuySupplyCard {
  supplyType: SupplyType.GroupBuy;
  productCard: ProductCard;
  poiCard: null;
}

// 团购商卡或下挂菜商卡
export type SupplyCard = WayneSupplyCard | GroupBuySupplyCard;
// 前端处理后的团购商卡、下挂菜商卡
export type EnhancedWayneSupplyCard = WayneSupplyCard & { poiCard: EnhancedPoi };
export type EnhancedGroupBuySupplyCard = GroupBuySupplyCard & { productCard: EnhancedProductCard };
export type EnhancedSupplyCard = EnhancedWayneSupplyCard | EnhancedGroupBuySupplyCard;

export interface SupplyListLxConfig {
  POI_CARD_BID_MC: {
    CARD: string, // 外卖商菜卡片
    SKU: string, // 下挂菜
    COUPON: string; // 下挂券
  },
  POI_CARD_BID_MV: {
    CARD: string,
    SKU: string,
    COUPON: string;
  },
  PRODUCT_CARD_BID_MV?: {
    CARD: string;
  },
  PRODUCT_CARD_BID_MC?: {
    CARD: string;
  }
}